import Slider from "react-slick";
import { AuthContext, base_url } from "../../context/Authcontext";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import LoginReg from "../LoginReg";

const SliderContainer = ({ CurrentSlider }) => {
  const { token, games } = CurrentSlider;

  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingBoxCount, setLoadingBoxCount] = useState(8); // NEW
  const { isAuthenticated } = useContext(AuthContext);
  

  useEffect(() => {
    if (token && games?.length > 0) {
      setLoading(false);
    }
  }, [token, games]);

  // NEW: Adjust shimmer box count based on screen width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setLoadingBoxCount(2);
      } else {
        setLoadingBoxCount(8);
      }
    };

    handleResize(); // initial run
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div _ngcontent-jrx-c85="" className="owl-next" onClick={onClick}>
        <img src="/assets/images/bannerArrow.svg" alt="Next" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div _ngcontent-jrx-c85="" className="owl-prev" onClick={onClick}>
        <img src="/assets/images/bannerArrow.svg" alt="Previous" />
      </div>
    );
  }

  var settings = {
    speed: 500,
    infinite: true,
    slidesToShow: 8,
    autoplay: true,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const openGameById = async ({ token, gameId }) => {
    try {
      if(!isAuthenticated){
        toast.error("Please Login to Play Games.");
        setActive(true);
        return;
      }
      const response = await axios.post(
        base_url + "/api/gamelaunch/url",
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      console.log('repp',response);
      if (response?.data.success) {
        toast.success("Redirecting to Game Lobby....");
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error(response?.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <LoginReg active={active} setactive={setActive} />
      {loading ? (
        <div className="special-mq-style">
          <div className="col-12 game-carousel popular_car">
            <div
              className="slider-container"
              style={{ display: "flex", gap: "22px", padding: "10px" }}
            >
              {Array.from({ length: loadingBoxCount }).map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "160.125px",
                    height: "100px",
                    background:
                      "linear-gradient(90deg, #2b2b2b 25%, #3c3c3c 50%, #2b2b2b 75%)",
                    backgroundSize: "400% 400%",
                    animation: "shimmer 1.5s infinite",
                    borderRadius: "12px",
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div _ngcontent-jrx-c95="" className=" special-mq-style">
          <div
            _ngcontent-jrx-c95=""
            className="col-12 game-carousel popular_car"
          >
            <owl-carousel-o _ngcontent-jrx-c95="" _nghost-jrx-c85="">
              <div
                _ngcontent-jrx-c85=""
                className="owl-carousel owl-theme owl-loaded owl-responsive owl-drag"
              >
                <div
                  _ngcontent-jrx-c85=""
                  className="owl-stage-outer ng-star-inserted"
                >
                  <owl-stage
                    _ngcontent-jrx-c85=""
                    className="ng-tns-c86-9 ng-star-inserted"
                  >
                    <div className="ng-tns-c86-9">
                      <div className="owl-stage ng-tns-c86-9">
                        <div className="slider-container">
                          <Slider {...settings}>
                            {games?.map((game, index) => {
                              return (
                                <div
                                  key={index}
                                  className="owl-item ng-tns-c86-9 ng-trigger ng-trigger-autoHeight ng-star-inserted cloned"
                                  style={{
                                    width: "160.125px",
                                    marginRight: "22px",
                                    marginBottom: "24 px",
                                  }}
                                  onClick={() =>
                                    openGameById({ token, gameId: game?.id })
                                  }
                                >
                                  <div
                                    _ngcontent-jrx-c95=""
                                    className="pop-carousel ng-star-inserted"
                                  >
                                    <img
                                      _ngcontent-jrx-c95=""
                                      className="slider-sports img-fluid"
                                      src={game?.images[2]?.url}
                                      alt={game?.category}
                                      loading="lazy"
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  </owl-stage>
                </div>
                <div
                  _ngcontent-jrx-c85=""
                  className="owl-nav ng-star-inserted"
                ></div>
                <div
                  _ngcontent-jrx-c85=""
                  className="owl-dots disabled ng-star-inserted"
                ></div>
              </div>
            </owl-carousel-o>
          </div>
        </div>
      )}

      {/* Skeleton Animation CSS */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -400% 0;
          }
          100% {
            background-position: 400% 0;
          }
        }
      `}</style>
    </>
  );
};

export default SliderContainer;
